$(document).ready(function() {
  const mainPageClassSelector            = ".stories_overview_page.page-container";
  const duplicationClassSelector         = ".story-duplication";
  const sourceApplicationIdSelector      = "#source_application_id";
  const sourceCourseIdSelector           = "#source_course_id";
  const sourceFunctionIdSelector         = "#source_function_id";
  const destinationApplicationIdSelector = "#destination_application_id";
  const destinationCourseIdSelector      = "#destination_course_id";
  const duplicationWarningsClassSelector = ".duplication-warnings";
  const spinnerClassSelector             = ".spinner";
  const urlForDuplicationWarnings        = "/duplication/story_duplications/warnings.json";

  const retrieveDuplicationWarningsForStoryDuplication = function({ formIdSelector, sourceApplicationId, sourceCourseId, sourceFunctionId, destinationCourseId }) {
    const payload = {
      source_application_id: sourceApplicationId,
      source_course_id:      sourceCourseId,
      source_function_id:    sourceFunctionId,
      destination_course_id: destinationCourseId,
    }

    retrieveDuplicationWarningsForStoryDuplicationPending(formIdSelector);

    $.ajax({
      url:         urlForDuplicationWarnings,
      method:      "POST",
      dataType:    "json",
      contentType: "application/json",
      data:        JSON.stringify(payload),
    }).done(function(response) {
      retrieveDuplicationWarningsForStoryDuplicationCompleted(formIdSelector);

      const duplicationWarningsElement = $(`${mainPageClassSelector} ${formIdSelector} ${duplicationWarningsClassSelector}`);

      if (duplicationWarningsElement) {
        if (response.available) {
          const duplicationWarningsHtml = duplicationWarningsForStoryDuplicationHtml(response);

          if (duplicationWarningsElement) {
            duplicationWarningsElement.html(duplicationWarningsHtml);
            duplicationWarningsElement.show();
          }
        } else {
          duplicationWarningsElement.hide();
        }
      }
    }).fail(function(error) {
      retrieveDuplicationWarningsForStoryDuplicationCompleted(formIdSelector);

      console.error(error);
    });
  }

  const retrieveDuplicationWarningsForStoryDuplicationPending = function(formIdSelector) {
    const duplicationWarningsElement = $(`${mainPageClassSelector} ${formIdSelector} ${duplicationWarningsClassSelector}`);
    const spinnerElement             = $(`${mainPageClassSelector} ${formIdSelector} ${spinnerClassSelector}`);
    const submitElement              = $(`${mainPageClassSelector} ${formIdSelector} input[type="submit"]`);

    if (duplicationWarningsElement) {
      duplicationWarningsElement.hide();
    }

    if (spinnerElement) {
      spinnerElement.show();
    }

    if (submitElement) {
      submitElement.hide();
    }
  }

  const retrieveDuplicationWarningsForStoryDuplicationCompleted = function(formIdSelector) {
    const spinnerElement = $(`${mainPageClassSelector} ${formIdSelector} ${spinnerClassSelector}`);
    const submitElement  = $(`${mainPageClassSelector} ${formIdSelector} input[type="submit"]`);

    if (spinnerElement) {
      spinnerElement.hide();
    }

    if (submitElement) {
      submitElement.show();
    }
  }

  const duplicationWarningsForStoryDuplicationHtml = function(response) {
    const duplicationWarningsHtml = $.map(response.details, function (warningDetail, index) {
      return `
        <dt class="duplication-warning-description">${index + 1}) ${warningDetail.description}</dt>
        <dd class="duplication-warning-message">${warningDetail.message}</dd>
      `;
    }).join("\n");

    return `
      <div class="duplication-warnings-summary">${response.summary}</div>
      <dl>${duplicationWarningsHtml}</dl>
    `;
  }

  $(mainPageClassSelector).on("change", `${duplicationClassSelector} ${destinationCourseIdSelector}`, function(event) {
    const currentElement = $(this);
    const closestForm    = currentElement.closest('form')[0];

    if (closestForm) {
      const formId                     = closestForm.id;
      const formIdSelector             = `#${formId}`;
      const sourceApplicationIdElement = $(`${formIdSelector} ${sourceApplicationIdSelector}`);
      const sourceCourseIdElement      = $(`${formIdSelector} ${sourceCourseIdSelector}`);
      const sourceFunctionIdElement    = $(`${formIdSelector} ${sourceFunctionIdSelector}`);

      if (sourceApplicationIdElement && sourceCourseIdElement && sourceFunctionIdElement) {
        const sourceApplicationId = sourceApplicationIdElement.val();
        const sourceCourseId      = sourceCourseIdElement.val();
        const sourceFunctionId    = sourceFunctionIdElement.val();
        const destinationCourseId = currentElement.val();

        retrieveDuplicationWarningsForStoryDuplication({ formIdSelector: formIdSelector, sourceApplicationId: sourceApplicationId, sourceCourseId: sourceCourseId, sourceFunctionId: sourceFunctionId, destinationCourseId: destinationCourseId });
      }
    }
  });
});
